// Expo 側の `~/tsubamecard-expo/src/lib/constants.ts` および
// `~/tsubamecard-expo/src/models/BusinessCard.ts` から
// Web 版に必要な定数だけ抜粋・流用。
// 変更したくなった場合は **両側を同期**(将来的に共有モジュール化検討)。

export const SHEETS_SCOPE = "https://www.googleapis.com/auth/drive.file";

// シート名(Google Drive 上の検索キー)
// ⚠️ iOS 版 `~/tsubamecard-expo/src/lib/constants.ts` と完全一致させること。
//     ズレるとシート読込みが API エラー(Unable to parse range)になる。
export const SHEET_TITLE = "つばめカード";
export const ACTIVE_SHEET_TITLE = "名刺ログ";
export const ARCHIVE_SHEET_TITLE = "アーカイブ";
export const META_SHEET_TITLE = "メタ";

// アクティブタブのヘッダ(23 列・2026-05-06 W列「タグ」を追加)
//
// ⚠️ iOS 版 SHEETS_HEADER は 2026-05-06 時点で 22 列(W列なし)。
// Web 版が先行で「タグ」列を追加し、iOS 版次回アップデート時に同期予定。
// それまでは ensureTagsColumn() で既存シートに W列を後付け追加する。
export const SHEETS_HEADER: readonly string[] = [
  "No",
  "取得日",
  "氏名",
  "会社",
  "部署",
  "役職",
  "郵便番号",
  "住所",
  "電話",
  "携帯",
  "FAX",
  "メール1",
  "メール2",
  "URL",
  "メモ",
  "画像",
  "画像ID",
  "氏名_英",
  "会社_英",
  "部署_英",
  "役職_英",
  "住所_英",
  "タグ", // W列(23列目)— Web版先行追加 / iOS同期待ち
] as const;

// 列インデックス(0始まり)
export const COL_TAGS = 22;

// アーカイブタブのヘッダ(SHEETS_HEADER + アーカイブ日 = 24 列)
export const ARCHIVE_HEADER: readonly string[] = [
  ...SHEETS_HEADER,
  "アーカイブ日",
] as const;

// タグの区切り(カンマ + 半角スペース許容)
export const TAG_SEPARATOR = ",";

// CSV/VCF インポート時の最大行数(Phase 1 の制限)
export const IMPORT_MAX_ROWS = 5000;
